<template>
<div>
  <h2 class="text-[13px] font-semibold text-[#23569F] uppercase leading-[1.5]">{{ $t('label.pin') }}</h2>
  <el-row>

    <el-col :span="10" :offset="8">
      <div class="grid-content">
        <player-setup-form-error :message="formError" :display="formError != ''" height="medium" />
        <el-form
            @submit.prevent="triggerFormSubmit"
            ref="refFormPin"
            :rules="modelRules"
            :model="model"
            class="common-form">
          <el-form-item :label="$t('label.serialNumber')" prop="serial">
            <el-input ref="serialInput" :readonly="true" v-model="serial"></el-input>
          </el-form-item>

          <el-form-item :label="$t('label.pin')" prop="pin" class="mt-8">
            <el-input
              id="player-setup-pin"
              ref="pinInput"
              :autofocus="true"
              :disabled="isFormDisabled"
              :model-value="model.pin"
              @update:model-value="newValue => model.pin = newValue"
              :placeholder="$t('label.pleaseEnterValidPin')">
              <template #suffix>
                <span v-if="model.pin" class="flex cursor-pointer" @click="() => $refs.pinInput.clear()">
                  <el-icon class="text-[#c0c4cc] hover:text-[#909399]"><CircleClose /></el-icon>
                </span>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script src="./player-setup-pin.js"></script>
